console.log('QuantityInput.js: File loaded, script execution started.');

try {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      console.log('QuantityInput: Constructor invoked.');
      this.input = this.querySelector('input[type="number"]');
      this.plusButton = this.querySelector('button[data-quantity="plus"]');
      this.minusButton = this.querySelector('button[data-quantity="minus"]');
      
      if (!this.input) {
        console.error('QuantityInput: Input element not found.');
      }
    }

    connectedCallback() {
      console.log('QuantityInput: connectedCallback invoked.');
      this.setupEventListeners();
      this.updateButtonStates();
    }

    disconnectedCallback() {
      if (this.plusButton) {
        this.plusButton.removeEventListener('click', this.handlePlusClick);
      }
      if (this.minusButton) {
        this.minusButton.removeEventListener('click', this.handleMinusClick);
      }
      if (this.input) {
        this.input.removeEventListener('input', this.handleInputChange);
      }
    }

    setupEventListeners() {
      if (this.plusButton) {
        this.plusButton.addEventListener('click', this.handlePlusClick.bind(this));
      }
      
      if (this.minusButton) {
        this.minusButton.addEventListener('click', this.handleMinusClick.bind(this));
      }
      
      if (this.input) {
        this.input.addEventListener('input', this.handleInputChange.bind(this));
        this.input.addEventListener('blur', this.handleInputBlur.bind(this));
      }
    }

    handlePlusClick(event) {
      event.preventDefault();
      if (!this.input) return;
      
      const currentValue = parseInt(this.input.value) || 0;
      const max = parseInt(this.input.max) || 999;
      const step = parseInt(this.input.step) || 1;
      
      const newValue = Math.min(currentValue + step, max);
      this.input.value = newValue;
      
      this.updateButtonStates();
      this.dispatchChangeEvent();
      
      console.log('QuantityInput: Increased to:', newValue);
    }

    handleMinusClick(event) {
      event.preventDefault();
      if (!this.input) return;
      
      const currentValue = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const step = parseInt(this.input.step) || 1;
      
      const newValue = Math.max(currentValue - step, min);
      this.input.value = newValue;
      
      this.updateButtonStates();
      this.dispatchChangeEvent();
      
      console.log('QuantityInput: Decreased to:', newValue);
    }

    handleInputChange() {
      this.validateInput();
      this.updateButtonStates();
      this.dispatchChangeEvent();
    }

    handleInputBlur() {
      this.validateInput();
      this.updateButtonStates();
    }

    validateInput() {
      if (!this.input) return;
      
      const value = parseInt(this.input.value);
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || 999;
      
      if (isNaN(value) || value < min) {
        this.input.value = min;
      } else if (value > max) {
        this.input.value = max;
      }
    }

    updateButtonStates() {
      if (!this.input) return;
      
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || 999;
      
      if (this.minusButton) {
        this.minusButton.disabled = value <= min;
      }
      
      if (this.plusButton) {
        this.plusButton.disabled = value >= max;
      }
    }

    dispatchChangeEvent() {
      if (!this.input) return;
      
      const event = new Event('change', { bubbles: true });
      this.input.dispatchEvent(event);
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
    console.log('QuantityInput.js: Custom element registered.');
  }

} catch (e) {
  console.error('QuantityInput.js: Critical error:', e);
}

console.log('QuantityInput.js: Script execution finished.');